import {put,takeLatest,call} from 'redux-saga/effects';
import * as orderService from "../../../services/orderService";
import {
    GET_ORDERS_OF_USER,
    GET_ORDERS_OF_USER_SUCCESS,
    GET_ORDERS_OF_USER_ERROR
}
    from "../../actions/order";
function* getOrdersOfUserSaga(action) {
    try {
        const data=yield call(orderService.GetOrdersOfUser,action.payload)
        yield put({
            type: GET_ORDERS_OF_USER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_ORDERS_OF_USER_ERROR,error: error.data
        });
    }
}

export function* getOrdersOfUserSagaWatcher() {
    yield takeLatest(GET_ORDERS_OF_USER,getOrdersOfUserSaga);
}